import { UnitInterface } from "../../../Entity/Entities/Unit/UnitInterface";
import { ContractInterface } from "../../../Entity/Entities/Contract/ContractInterface";
import { ChargeTemplateInterface } from "../../../Entity/Entities/Charge/ChargeTemplateInterface";
import Translator from "../../../Translation/Translator";
import Formatter from "../../../Localization/Formatter";
import { saveAs } from 'file-saver';
const XLSX = require ("xlsx");

class UnitSpreadSheet {
	protected fitToColumn = (arrayOfArray) => {
		// get maximum character of each column
		return arrayOfArray[0].map((_a, i) => ({ wch: Math.max(...arrayOfArray.map(a2 => (a2[i] || "").toString().length)) }));
	}

	protected getDataArray = (units: UnitInterface[]) => {
		const dataArray = [];

		const titles = [
      Translator.trans("spreadsheet/unit-property"),
      Translator.trans("spreadsheet/unit-type"),
      Translator.trans("spreadsheet/unit-defaultdeposit"),
      Translator.trans("spreadsheet/unit-defaultbasicrent"),
      Translator.trans("spreadsheet/unit-agreementservice"),
      Translator.trans("spreadsheet/unit-agreementagencyfee"),

      // contract headers
      Translator.trans("spreadsheet/unit-contracttenant"),
      Translator.trans("spreadsheet/unit-contractoccupants"),
      Translator.trans("spreadsheet/unit-contractstatus"),
      Translator.trans("spreadsheet/unit-contractdeposit"),
      Translator.trans("spreadsheet/unit-contractbasicrent"),
      Translator.trans("spreadsheet/unit-contractfirstdate"),
      Translator.trans("spreadsheet/unit-contractenddate"),
      Translator.trans("spreadsheet/unit-contractexpirationdate1"),
      Translator.trans("spreadsheet/unit-contractexpirationdate2"),
      Translator.trans("spreadsheet/unit-contractnotificationdate"),
    ]
    
    dataArray.push(titles);
    dataArray.push([]);

    units
      .filter((unit: UnitInterface) => !unit?.removed)
      .forEach((unit: UnitInterface) => {
        let unitServiceStatus = ""
        if (unit?.unitServiceStatus?.label === "INACTIVE") {
          unitServiceStatus = Translator.trans("unit_service_status_type_inactive");
        }
    
        if (unit?.unitServiceStatus?.label === "MANAGEMENT") {
          unitServiceStatus = Translator.trans("unit_service_status_type_management");
        }

        const basicRentChargeTemplates = unit?.defaultChargeTemplates?.filter((chargeTemplate: ChargeTemplateInterface) => !chargeTemplate.removed && chargeTemplate?.type?.label === "Basic_rent")
                                          .map((chargeTemplate: ChargeTemplateInterface) => `${Formatter.checkTranslationType(Translator.trans(chargeTemplate?.type?.label, {}, "", chargeTemplate?.type?.system), chargeTemplate?.type?.label, chargeTemplate?.type?.system)} ${Formatter.formatNumber(chargeTemplate?.amount, chargeTemplate?.currency)}`);
        const depositChargeTemplates = unit?.defaultChargeTemplates?.filter((chargeTemplate: ChargeTemplateInterface) => !chargeTemplate.removed && chargeTemplate?.type?.label === "Deposit")
                                          .map((chargeTemplate: ChargeTemplateInterface) => `${Formatter.checkTranslationType(Translator.trans(chargeTemplate?.type?.label, {}, "", chargeTemplate?.type?.system), chargeTemplate?.type?.label, chargeTemplate?.type?.system)} ${Formatter.formatNumber(chargeTemplate?.amount, chargeTemplate?.currency)}`);
        const agencyFee = unit?.defaultAgencyFees?.filter(agencyFee => !agencyFee.removed)?.[0];
        const agencyFeeString = agencyFee ? `${Formatter.formatNumber(agencyFee?.fixedFee, agencyFee?.currency)}, ${Formatter.simpleFormatNumber(agencyFee?.percentageFee, false)}%, ${Formatter.checkTranslationType(Translator.trans(agencyFee?.fixedPlusPercentageMode?.label), agencyFee?.fixedPlusPercentageMode?.label)}` : "";
                                        

        const unitData: string[] = [
          unit?.displayName,
          Translator.trans(unit?.type?.label),
          depositChargeTemplates.join(" | "),
          basicRentChargeTemplates.join(" | "),
          unitServiceStatus,
          agencyFeeString,
        ];
        const contracts: ContractInterface[] = unit?.contracts?.filter((contract: ContractInterface) => !contract.removed && contract?.isActive);

        if (!contracts?.length) {
          return dataArray.push(unitData);
        }
        
        contracts.forEach((contract: ContractInterface) => {
          const basicRentChargeTemplates = contract?.chargeTemplates?.filter((chargeTemplate: ChargeTemplateInterface) => !chargeTemplate.removed && chargeTemplate?.type?.label === "Basic_rent")
                                          .map((chargeTemplate: ChargeTemplateInterface) => `${Formatter.checkTranslationType(Translator.trans(chargeTemplate?.type?.label, {}, "", chargeTemplate?.type?.system), chargeTemplate?.type?.label, chargeTemplate?.type?.system)} ${Formatter.formatNumber(chargeTemplate?.amount, chargeTemplate?.currency)}`);
          const depositChargeTemplates = contract?.chargeTemplates?.filter((chargeTemplate: ChargeTemplateInterface) => !chargeTemplate.removed && chargeTemplate?.type?.label === "Deposit")
                                          .map((chargeTemplate: ChargeTemplateInterface) => `${Formatter.checkTranslationType(Translator.trans(chargeTemplate?.type?.label, {}, "", chargeTemplate?.type?.system), chargeTemplate?.type?.label, chargeTemplate?.type?.system)} ${Formatter.formatNumber(chargeTemplate?.amount, chargeTemplate?.currency)}`);
          const occupants = (contract?.occupants || []).map(occupant => {
            return `${occupant?.person?.displayName}`
          });
          const occupantsString = occupants.join(", ");

          const contractData = [
            contract?.tenantDisplayName,
            occupantsString,
            Translator.trans(contract?.contractStatus),
            depositChargeTemplates.join(" | "),
						basicRentChargeTemplates.join(" | "),
            Formatter.formatDate(contract?.firstDate),
            Formatter.formatDate(contract?.endDate),
            Formatter.formatDate(contract?.lastDate),
            Formatter.formatDate(contract?.finalRentalPeriodDate),
            Formatter.formatDate(contract?.expirationDate),
          ];

          return dataArray.push([...unitData, ...contractData]);
        });
      });

		return [...dataArray];
	}

	protected saveBook = (s) => {
		var buf = new ArrayBuffer(s.length);
		var view = new Uint8Array(buf);
		for (var i = 0; i < s.length; i++) {
			view[i] = s.charCodeAt(i) & 0xff;
		}
		return buf;
	}

	public download(units: UnitInterface[]) {
		var unitSpreadSheet = XLSX.utils.book_new();

    (unitSpreadSheet as any).props = {
      title: Translator.trans("title-units"),
      subject: Translator.trans("title-units"),
      Ather: "Casadesk",
      createdDate: Date.now(),
    };
    unitSpreadSheet.SheetNames.push(Translator.trans("title-units"));

		const dataArray = this.getDataArray(units);
    var sheetFromArrayData = XLSX.utils.aoa_to_sheet(dataArray);
    sheetFromArrayData['!cols'] = this.fitToColumn(dataArray);

    unitSpreadSheet.Sheets[Translator.trans("title-units")] = sheetFromArrayData;
    var book = XLSX.write(unitSpreadSheet, { bookType: "xlsx", type: "binary" });

    saveAs(
      new Blob([this.saveBook(book)], { type: "application/octet-stream" }),
      `${Translator.trans("title-units")}.xlsx`
    );
	}
}


export default new UnitSpreadSheet();